import * as React from 'react'
import {
  FormTextArea,
  FormEuroField,
  FormIntegerField,
  FormSumField,
  FormField
} from '@espoon-voltti/react-voltti/components/form'
import {
  Title,
  Columns,
  Column
} from '@espoon-voltti/react-components/elements'
import { Spacing } from '@espoon-voltti/react-components/layout'

import { t } from '../../../../i18n'
import { sumOf } from '../../../../utils'

export const GeneralGrantFormData = () => (
  <Columns>
    <Column size={10}>
      <Columns>
        <Column size={8}>
          <FormTextArea
            dataQa={'detailsOfUse'}
            required={true}
            name={'form.detailsOfUse'}
            label={t([
              'views',
              'generalGrant',
              'form',
              'appDetails',
              'detailsOfUse'
            ])}
          />
        </Column>
        <Column>
          <FormEuroField
            dataQa={'appliedSumInCents'}
            required={true}
            name={'form.appliedSum'}
            label={t([
              'views',
              'generalGrant',
              'form',
              'appDetails',
              'appliedSumInCents'
            ])}
          />
        </Column>
      </Columns>

      <Columns>
        <Column size={10}>
          <Title size={3} dataQa={'participants'}>
            {t(['views', 'generalGrant', 'form', 'participants', 'title'])}
          </Title>

          <Spacing spacing={['margin-bottom--1']}>
            <p>
              {t(['views', 'generalGrant', 'form', 'participants', 'desc_1'])}
            </p>
          </Spacing>
          <Spacing spacing={['margin-bottom--1']}>
            <p>
              {t(['views', 'generalGrant', 'form', 'participants', 'desc_2'])}
            </p>
          </Spacing>
          <Spacing spacing={['margin-bottom--2']}>
            <p>
              {t(['views', 'generalGrant', 'form', 'participants', 'desc_3'])}
            </p>
          </Spacing>

          <Columns>
            <Column>
              <FormIntegerField
                label={t([
                  'views',
                  'generalGrant',
                  'form',
                  'participants',
                  'from7to20'
                ])}
                name={'form.participants.from7to20'}
                dataQa={'participantsFrom7to20'}
                required={true}
              />
            </Column>
            <Column>
              <FormIntegerField
                label={t([
                  'views',
                  'generalGrant',
                  'form',
                  'participants',
                  'from21to28'
                ])}
                name={'form.participants.from21to28'}
                dataQa={'participantsFrom21to28'}
                required={true}
              />
            </Column>
            <Column>
              <FormSumField
                label={t([
                  'views',
                  'generalGrant',
                  'form',
                  'participants',
                  'total'
                ])}
                name={'form.participants.total'}
                dataQa={'participantsTotal'}
                sumFieldNames={[
                  'form.participants.from7to20',
                  'form.participants.from21to28'
                ]}
                valueFormatter={sumOf}
              />
            </Column>
          </Columns>
        </Column>
      </Columns>

      <Columns>
        <Column size={10}>
          <Title size={4} dataQa={'goals'}>
            {t(['views', 'generalGrant', 'form', 'goals', 'title'])}
          </Title>

          <Columns>
            <Column>
              <FormField
                label={t(['views', 'generalGrant', 'form', 'goals', 'goals_1'])}
                name={'form.goals.goals1'}
                dataQa={'goals1'}
                required={true}
              />
            </Column>
          </Columns>
          <Columns>
            <Column>
              <FormField
                label={t(['views', 'generalGrant', 'form', 'goals', 'goals_2'])}
                name={'form.goals.goals2'}
                dataQa={'goals2'}
              />
            </Column>
          </Columns>
          <Columns>
            <Column>
              <FormField
                label={t(['views', 'generalGrant', 'form', 'goals', 'goals_3'])}
                name={'form.goals.goals3'}
                dataQa={'goals3'}
              />
            </Column>
          </Columns>

          <Columns>
            <Column>
              <FormTextArea
                label={
                  <span>
                    {t([
                      'views',
                      'generalGrant',
                      'form',
                      'youngEspoo',
                      'title_1'
                    ])}
                    {t([
                      'views',
                      'generalGrant',
                      'form',
                      'youngEspoo',
                      'title_link'
                    ])}
                    {t([
                      'views',
                      'generalGrant',
                      'form',
                      'youngEspoo',
                      'title_2'
                    ])}
                  </span>
                }
                required={true}
                name={'form.youngEspoo'}
                dataQa={'youngEspoo'}
              />
            </Column>
          </Columns>
          <Columns>
            <Column>
              <FormTextArea
                label={t([
                  'views',
                  'generalGrant',
                  'form',
                  'financialPlan',
                  'label'
                ])}
                placeholder={t([
                  'views',
                  'generalGrant',
                  'form',
                  'financialPlan',
                  'placeholder'
                ])}
                name={'form.financialPlan'}
                dataQa={'financialPlan'}
                required={true}
              />
            </Column>
          </Columns>
        </Column>
      </Columns>
    </Column>
  </Columns>
)
